"use client";

import type * as React from "react";

import { LineBlob } from "./LineBlob";

/**
 * LoginBlob — public wrapper for the Ando brand visual on login + chat.
 *
 * EXPERIMENT (June 2026): renders the clean "pencil-line" `LineBlob` (an orange
 * morphing OUTLINE) in place of the WebGL metaballs (`AndoBrain`) EVERYWHERE
 * LoginBlob is used — login hero, chat streaming indicator, project anchors,
 * AiCopilot bar, and the marketing landing (apps/web). The `size` API is
 * unchanged so no consumer needs editing.
 *
 * To revert to the metaballs: restore the previous `AndoBrain`-based body from
 * git — `AndoBrain` / `AndoBrainLoader` / `BlobFallback` remain exported and
 * unchanged, so the metaballs core is untouched.
 */
export type LoginBlobSize = "hero" | "mini";

export interface LoginBlobProps {
  size?: LoginBlobSize;
}

export const LoginBlob: React.FC<LoginBlobProps> = ({ size = "hero" }) => (
  <LineBlob size={size} />
);
LoginBlob.displayName = "LoginBlob";
